import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import moment from 'moment';
import { useParams, useSearchParams } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

import useGetReportAttendanceHostDetail from 'Domain/report-attendance-host-detail/useGetReportAttendanceHostDetail';

import ReportAttendanceHostDetailProvider, { useReportAttendanceHostDetailState } from 'View/report-attendance-host-detail/state';
import Head from 'View/report-attendance-host-detail/section/head';
import Filter from 'View/report-attendance-host-detail/section/filter';
import Table from 'View/report-attendance-host-detail/section/table';

import styles from './styles.module.css';

const ReportAttendanceHostDetail = () => {
  const { t } = useTranslation('report-attendance-host-detail');
  const params = useParams();
  const [searchParams] = useSearchParams();
  const { filterState, updateFilterState } = useReportAttendanceHostDetailState();

  const paramsDate = searchParams.get('date');

  useEffect(() => {
    if (!paramsDate) {
      const now = moment();
      updateFilterState({
        startedAt: now.clone().startOf('month').toDate(),
        endedAt: now.toDate(),
      });
      return;
    }

    const [start, end] = paramsDate.split('-');

    updateFilterState({
      startedAt: moment(start, 'DDMMYYYY').toDate(),
      endedAt: moment(end, 'DDMMYYYY').toDate(),
    });
  }, [paramsDate]); // eslint-disable-line react-hooks/exhaustive-deps

  const { data, isFetching } = useGetReportAttendanceHostDetail({
    ...filterState,
    userId: params?.id,
  });

  return (
    <Box className={styles['attendance-report__container']}>
      <Head data={data} isFetching={isFetching} t={t} />
      <Filter userId={params?.id || ''} t={t} />
      <Table data={data} isFetching={isFetching} t={t} />
    </Box>
  );
};

const ReportAttendanceHostDetailContainer = () => {
  return (
    <ReportAttendanceHostDetailProvider>
      <ReportAttendanceHostDetail />
    </ReportAttendanceHostDetailProvider>
  );
};

export default ReportAttendanceHostDetailContainer;
